import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getNewsCategoryById} from '../core/_requests'
import {NewsCategoryEditModalForm} from './NewsCategoryEditModalForm'

const NewsCategoryEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: newsCategory,
    error,
  } = useQuery(
    `${QUERIES.NEWS_CATEGORY_LIST}-${itemIdForUpdate}`,
    () => {
      const newsCategory = getNewsCategoryById(itemIdForUpdate)
      return newsCategory
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <NewsCategoryEditModalForm isUserLoading={isLoading} newsCategory={{id: undefined}} />
  }
  if (!isLoading && !error && newsCategory) {
    return <NewsCategoryEditModalForm isUserLoading={isLoading} newsCategory={newsCategory} />
  }

  return null
}

export {NewsCategoryEditModalFormWrapper}
